"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormComponent = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("skybase-ui/skybase-core/shapes");

var _skybaseComponents = require("skybase-ui/skybase-components");

var _constants = require("./constants");

var _validator = require("../../validator");

var _auth = require("../../auth");

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return (0, _typeof2.default)(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if ((0, _typeof2.default)(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if ((0, _typeof2.default)(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FormComponent = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(FormComponent, _PureComponent);

  var _super = _createSuper(FormComponent);

  function FormComponent(_props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormComponent);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnConfirmClick", function () {
      var _this$props = _this.props,
          handleOnConfirm = _this$props.handleOnConfirm,
          pageSize = _this$props.pageSize,
          pageNumber = _this$props.pageNumber;

      var _ref = _this.dataInState ? _this.state : _this.props,
          data = _ref.data;

      var errors = (0, _validator.validator)(_this.validationRules, data, _this.customValidators);

      _this.setState({
        errors: errors
      }, function () {
        var _this$formRef, _this$formRef$parentN, _this$formRef$parentN2, _this$formRef$parentN3, _this$formRef$parentN4;

        var attribute = errors && Object.keys(errors)[0];
        var element = attribute && _this.formRefs[attribute];

        if (element && ((_this$formRef = _this.formRef) === null || _this$formRef === void 0 ? void 0 : (_this$formRef$parentN = _this$formRef.parentNode) === null || _this$formRef$parentN === void 0 ? void 0 : _this$formRef$parentN.scrollTo) && ((_this$formRef$parentN2 = _this.formRef.parentNode) === null || _this$formRef$parentN2 === void 0 ? void 0 : (_this$formRef$parentN3 = _this$formRef$parentN2.classList) === null || _this$formRef$parentN3 === void 0 ? void 0 : (_this$formRef$parentN4 = _this$formRef$parentN3.contains) === null || _this$formRef$parentN4 === void 0 ? void 0 : _this$formRef$parentN4.call(_this$formRef$parentN3, 'dynamic-tab-content'))) {
          _this.formRef.parentNode.scrollTo(0, element.offsetTop - 10);
        }
      }); // Normalize data from given attributes with the given normalizeFunction


      var normalizedData = _this.beforeConfirm.reduce(function (acc, attribute) {
        var name = attribute.name,
            normalize = attribute.normalize;

        if (Object.prototype.hasOwnProperty.call(data, name)) {
          acc[name] = normalize(data[name]);
        }

        return acc;
      }, {});

      if ((0, _isEmpty.default)(errors)) {
        if (handleOnConfirm) {
          handleOnConfirm(_objectSpread(_objectSpread({}, data), normalizedData), {
            pageSize: pageSize,
            pageNumber: pageNumber
          });
        } else if (_this.handleOnConfirm) {
          _this.handleOnConfirm(_objectSpread(_objectSpread({}, data), normalizedData), {
            pageSize: pageSize,
            pageNumber: pageNumber
          });
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnChange", function (_ref2) {
      var event = _ref2.event,
          attribute = _ref2.attribute,
          _ref2$values = _ref2.values,
          values = _ref2$values === void 0 ? null : _ref2$values;
      var handleOnChangeParams = _this.props.handleOnChangeParams;
      var value = event.target ? event.target.value : event;

      if (values) {
        value = values.floatValue;
      }

      if (handleOnChangeParams) {
        handleOnChangeParams(attribute, value);
      } else if (_this.handleOnChangeParams) {
        _this.handleOnChangeParams(attribute, value);
      } // Move the setState to the end of the stack to maintain the cursor position.


      setTimeout(function () {
        // Reset the error for the current attribute
        _this.setState(function (prevState) {
          var _prevState$errors = prevState.errors,
              oldAttribute = _prevState$errors[attribute],
              restErrors = (0, _objectWithoutProperties2.default)(_prevState$errors, [attribute].map(_toPropertyKey));
          return {
            errors: restErrors
          };
        });
      }, 0);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnBlur", function (attribute) {
      var _ref3 = _this.dataInState ? _this.state : _this.props,
          data = _ref3.data;

      var value = data[attribute];
      var value2 = attribute === 'confirmPassword' ? {
        password: data.password
      } : {};
      var errors = (0, _validator.validator)(_this.validationRules, _objectSpread((0, _defineProperty2.default)({}, attribute, value), value2))[attribute];

      if (errors) {
        // Move the setState to the end of the stack.
        setTimeout(function () {
          _this.setState(function (prevState) {
            return {
              errors: _objectSpread(_objectSpread({}, prevState.errors), {}, (0, _defineProperty2.default)({}, attribute, errors))
            };
          });
        }, 1);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleRefs", function (node, attribute) {
      _this.formRefs[attribute] = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getLabelClassNames", function (className) {
      return (0, _classnames.default)(className, {
        'sb-width-l': _this.isModal,
        'sb-width-100pct': !_this.isModal
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHintTitle", function (title) {
      var hintData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!hintData) {
        return title;
      }

      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbHint, {
        className: "m-l-5",
        hintClassName: "form-label-hint",
        position: {
          vertical: 'middle',
          horizontal: 'right'
        },
        hintData: hintData
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "sbi-toast-info"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderComponentByType", function (type, props) {
      switch (type) {
        case 'checkbox':
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbCheckbox, props);

        case 'password':
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbPassword, (0, _extends2.default)({
            autoComplete: "new-password"
          }, props));

        case 'select':
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbDropdownButton, (0, _extends2.default)({
            maxHeight: _constants.DROPDOWN_BUTTON_MAX_HEIGHT
          }, props));

        case 'multiselect':
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbMultiselect, (0, _extends2.default)({
            liveSearch: true,
            maxHeight: _constants.MULTI_SELECT_MAX_HEIGHT
          }, props));

        case 'textarea':
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbTextarea, props);

        default:
          return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbTextbox, props);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputWithLabel", function (attribute, title) {
      var _objectSpread4;

      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errors = _this.state.errors;
      var _this$props2 = _this.props,
          loading = _this$props2.loading,
          write = _this$props2.acl.write,
          disabledForm = _this$props2.disabled;

      var _ref4 = _this.dataInState ? _this.state : _this.props,
          data = _ref4.data;

      var error = errors && errors[attribute];
      var value = data[attribute];
      var componentType = props.componentType,
          disabled = props.disabled,
          hint = props.hint,
          className = props.className,
          labelClassName = props.labelClassName,
          restProps = (0, _objectWithoutProperties2.default)(props, ["componentType", "disabled", "hint", "className", "labelClassName"]);
      var classNameKey = componentType === 'password' || props.addonLeft || props.addonRight ? 'outerClassName' : 'className';
      var hasError = Array.isArray(error) && error.length > 0;
      var isRequired = (0, _validator.isFieldRequired)(_this.validationRules, attribute);

      var commonProps = _objectSpread(_objectSpread({}, restProps), {}, (_objectSpread4 = {}, (0, _defineProperty2.default)(_objectSpread4, classNameKey, (0, _classnames.default)('sb-width-100pct', className)), (0, _defineProperty2.default)(_objectSpread4, "onChange", function onChange(event, values) {
        return _this.handleOnChange({
          event: event,
          attribute: attribute,
          values: values,
          componentType: componentType
        });
      }), (0, _defineProperty2.default)(_objectSpread4, "disabled", loading || disabled || !write || disabledForm), (0, _defineProperty2.default)(_objectSpread4, "hasError", hasError), (0, _defineProperty2.default)(_objectSpread4, "onBlur", function onBlur() {
        return _this.handleOnBlur(attribute);
      }), _objectSpread4), componentType === 'select' || componentType === 'multiselect' ? {
        selected: value
      } : {
        value: value !== null && value !== void 0 ? value : ''
      });

      var renderedTitle = _this.renderHintTitle(title, hint);

      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: renderedTitle,
        errorMessage: hasError ? error[0] : null,
        hasError: hasError,
        required: isRequired,
        className: _this.getLabelClassNames(labelClassName),
        labelRef: function labelRef(node) {
          return _this.handleRefs(node, attribute);
        }
      }, _this.renderComponentByType(componentType, commonProps));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderButtonBarWithLabel", function (attribute, title) {
      var radios = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var normalizeValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (v) {
        return v;
      };
      var _this$props3 = _this.props,
          loading = _this$props3.loading,
          write = _this$props3.acl.write,
          disabledForm = _this$props3.disabled;

      var _ref5 = _this.dataInState ? _this.state : _this.props,
          data = _ref5.data;

      var value = normalizeValue(data[attribute]);
      var disabled = props.disabled,
          hint = props.hint,
          labelClassName = props.labelClassName,
          restProps = (0, _objectWithoutProperties2.default)(props, ["disabled", "hint", "labelClassName"]);

      var renderedTitle = _this.renderHintTitle(title, hint);

      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: renderedTitle,
        className: _this.getLabelClassNames(labelClassName),
        labelRef: function labelRef(node) {
          return _this.handleRefs(node, attribute);
        }
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButtonBar, (0, _extends2.default)({}, restProps, {
        disabled: loading || disabled || !write || disabledForm
      }), radios.map(function (radio) {
        var radioTitle = radio.title,
            radioValue = radio.value;
        return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbRadioButton, {
          key: "".concat(attribute, "-radio-").concat(radioValue),
          checked: radioValue === value,
          onChange: function onChange() {
            return _this.handleOnChange({
              event: radioValue,
              attribute: attribute
            });
          }
        }, radioTitle);
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEditableListWithLabel", function (attribute, title) {
      var _error$;

      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var errors = _this.state.errors;
      var _this$props4 = _this.props,
          loading = _this$props4.loading,
          write = _this$props4.acl.write,
          disabledForm = _this$props4.disabled;

      var _ref6 = _this.dataInState ? _this.state : _this.props,
          data = _ref6.data;

      var value = data[attribute];
      var disabled = props.disabled,
          hint = props.hint,
          labelClassName = props.labelClassName,
          restProps = (0, _objectWithoutProperties2.default)(props, ["disabled", "hint", "labelClassName"]);
      var isRequired = (0, _validator.isFieldRequired)(_this.validationRules, attribute);
      var error = errors && errors[attribute];
      var hasError = Array.isArray(error) && error.length > 0;
      var errorMessage = hasError && error[0] ? ((_error$ = error[0]) === null || _error$ === void 0 ? void 0 : _error$.message) || error[0] : null;
      var errorIndexes = hasError ? error.reduce(function (acc, e) {
        if ((0, _typeof2.default)(e) === 'object') {
          return acc.concat(e.indexes);
        }

        return acc;
      }, []) : [];

      var renderedTitle = _this.renderHintTitle(title, hint);

      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: renderedTitle,
        className: _this.getLabelClassNames(labelClassName),
        errorMessage: errorMessage,
        hasError: hasError,
        labelRef: function labelRef(node) {
          return _this.handleRefs(node, attribute);
        },
        required: isRequired
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbEditableList, (0, _extends2.default)({
        draggable: false,
        controls: {
          arrows: 'hidden',
          remove: (value === null || value === void 0 ? void 0 : value.length) <= 1 ? 'disabled' : 'enabled'
        }
      }, restProps, {
        disabled: loading || disabled || !write || disabledForm,
        items: (value === null || value === void 0 ? void 0 : value.map(function (item, index) {
          return _objectSpread(_objectSpread({}, item), {}, {
            hasError: errorIndexes.indexOf(index) !== -1
          });
        })) || [],
        onBlur: function onBlur() {
          return _this.handleOnBlur(attribute);
        },
        onChange: function onChange(changedItems) {
          return _this.handleOnChange({
            event: changedItems,
            attribute: attribute
          });
        }
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputs", function () {
      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAdditionalControl", function () {
      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderBeforeConfirmButton", function () {
      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderConfirmButton", function () {
      var _this$props5 = _this.props,
          loading = _this$props5.loading,
          disabledForm = _this$props5.disabled;

      var _ref7 = _this.dataInState ? _this.state : _this.props,
          data = _ref7.data;

      var confirmButtonDisabled = data.id !== undefined && data.id === null;
      return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLoaderButton, {
        loading: loading,
        className: "sb-width-100pct primary",
        onClick: _this.handleOnConfirmClick,
        disabled: loading || confirmButtonDisabled || disabledForm
      }, _this.confirmButtonTitle);
    });
    _this.validationRules = [];
    _this.confirmButtonTitle = null;
    _this.state = {
      errors: {}
    };
    _this.isModal = false;
    _this.beforeConfirm = [];
    _this.customValidators = {};
    _this.formRefs = {};
    _this.formRef = null;
    _this.dataInState = false;
    return _this;
  }

  (0, _createClass2.default)(FormComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var write = this.props.acl.write;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-form",
        ref: function ref(node) {
          _this2.formRef = node;
        }
      }, this.renderInputs()), write && /*#__PURE__*/_react.default.createElement("div", {
        className: "form-button-controls"
      }, this.renderBeforeConfirmButton(), this.renderConfirmButton(), this.renderAdditionalControl()));
    }
  }]);
  return FormComponent;
}(_react.PureComponent);

exports.FormComponent = FormComponent;
(0, _defineProperty2.default)(FormComponent, "propTypes", {
  intl: _shapes.intlShape.isRequired,
  handleOnConfirm: _propTypes.default.func,
  handleOnChangeParams: _propTypes.default.func,
  pageSize: _propTypes.default.number,
  pageNumber: _propTypes.default.number,
  loading: _propTypes.default.bool.isRequired,
  acl: _auth.aclShape,
  disabled: _propTypes.default.bool
});
(0, _defineProperty2.default)(FormComponent, "defaultProps", {
  handleOnConfirm: null,
  handleOnChangeParams: null,
  pageSize: 10,
  pageNumber: 1,
  acl: {
    read: true,
    write: true
  },
  disabled: false
});
//# sourceMappingURL=form-component.js.map